import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", null, "카테고리 이름", -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", null, "노출 순서", -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", null, "하위 이름", -1)
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", null, "이벤트 키 값", -1)
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-sm-6" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-sm-6" }
const _hoisted_24 = { class: "form-group mb-5" }
const _hoisted_25 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_26 = /*#__PURE__*/_createVNode("label", null, "노출 여부", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_upload = _resolveComponent("file-upload")
  const _component_SubmitButton = _resolveComponent("SubmitButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("form", {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
        class: { loading: _ctx.loading }
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.category.name = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.category.name]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createVNode("input", {
                type: "number",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.category.order_number = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.category.order_number]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.category.sub_name = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.category.sub_name]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.category.event_key = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.category.event_key]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _createVNode(_component_file_upload, {
                ref: "thumbnailFile",
                "folder-name": 'pro-post-categories',
                "set-preview-img": _ctx.setPreviewImg
              }, null, 8, ["set-preview-img"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              _createVNode("label", _hoisted_25, [
                _hoisted_26,
                _withDirectives(_createVNode("input", {
                  type: "checkbox",
                  class: "c-switch-input",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.category.status = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.category.status]
                ]),
                _hoisted_27
              ])
            ])
          ])
        ]),
        _createVNode(_component_SubmitButton, {
          text: "저장",
          loadingText: " Saving...",
          isSubmitting: _ctx.isSubmitting
        }, null, 8, ["isSubmitting"])
      ], 34)
    ])
  ]))
}